import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import PlaceholderIcon from "../Placeholder/Placeholder";
import {
  convertImageNameToWeb,
  willBackorder,
} from "../../../helpers/helperFunctions";
import { addCartItem } from "../../../store/slices/CartSlice/CartSlice";
import { useEffect, useState } from "react";
import CartItemCounter from "../CartItemCounter/CartItemCounter";
import BackorderConfirmModal from "../BackorderConfirmModal/BackorderConfirmModal";

export default function ItemDetailPopup({ show, setShow }) {
  const { popupProduct } = useSelector((state) => state.productFinder);
  const { cartItems } = useSelector((state) => state.cart);
  const [cartItem, setCartItem] = useState(undefined);
  const [showBackorderConfirm, setShowBackorderConfirm] = useState(false);

  useEffect(() => {
    setCartItem(
      cartItems.find((item) => item.product_code === popupProduct.product_code)
    );
  }, [cartItems, popupProduct]);

  const dispatch = useDispatch();

  const dispatchAddCartItem = () => {
    dispatch(
      addCartItem({
        product_code: popupProduct.product_code,
        last_price: popupProduct.price ,
        product: {
          shipping_weight: popupProduct.shipping_weight,
          description: popupProduct.description,
        },
      })
    );
    setShow(false);
  };

  const handleAddCartItem = () => {
    if (willBackorder(popupProduct, cartItem?.quantity || 0)) {
      setShowBackorderConfirm(true);
      return;
    }
    dispatchAddCartItem();
  };

  const handleConfirmBackorder = () => {
    setShowBackorderConfirm(false);
    dispatchAddCartItem();
  };

  return (
    <Dialog open={show || false} onClose={setShow} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-lg data-closed:sm:translate-y-0 data-closed:sm:scale-95"
          >
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="flex flex-col sm:flex-row sm:items-start gap-4">
                <div className="mx-auto mt-5 flex size-36 shrink-0 items-center justify-center rounded-full  sm:mx-0">
                  {popupProduct.image_name ? (
                    <div>
                      <img
                        alt={popupProduct.image_name}
                        src={
                          process.env.REACT_APP_IMAGE_URL +
                          convertImageNameToWeb(popupProduct.image_name)
                        }
                      />
                    </div>
                  ) : (
                    <PlaceholderIcon />
                  )}
                </div>
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <DialogTitle
                    as="h3"
                    className="text-base font-semibold text-gray-900"
                  >
                    <div className="font-bold">{popupProduct.description}</div>
                    <div className="text-xs">
                      {popupProduct.xref_code
                        ? `Customer Product Code: ${popupProduct.xref_code}`
                        : undefined}
                    </div>
                    <div className="text-xs">
                      Product Code: {popupProduct.product_code}
                    </div>
                  </DialogTitle>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Price:{" "}
                      {popupProduct.price ? `$${popupProduct.price}` : "-"}
                    </p>
                    <p className="text-sm text-gray-500">
                      Ship Weight: {popupProduct.shipping_weight} lbs
                    </p>
                    <p className="text-sm text-gray-500">
                      You ordered this on: {popupProduct.date_ordered}{" "}
                      {/* TODO this will one day be a link to the order */}
                      {popupProduct.last_order_num
                        ? `(${popupProduct.last_order_num})`
                        : ""}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 mt-5 gap-2">
              {cartItem ? (
                <CartItemCounter cartItem={cartItem} className="mt-2" />
              ) : (
                <button
                  type="button"
                  onClick={handleAddCartItem}
                  className="inline-flex w-full justify-center rounded-md bg-[var(--primary-color)] px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-[var(--secondary-color)] sm:ml-3 sm:w-auto"
                >
                  Add to Cart
                </button>
              )}
              <button
                type="button"
                data-autofocus
                onClick={() => setShow(false)}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                close
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>

      <BackorderConfirmModal
        show={showBackorderConfirm}
        onConfirm={handleConfirmBackorder}
        onCancel={() => setShowBackorderConfirm(false)}
      />
    </Dialog>
  );
}
